module.exports = __webpack_public_path__ + "img/stone-vein.49eb14ee.png";